


import { Component, OnInit, NgZone } from '@angular/core';
import  { Router } from '@angular/router';

import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FirebaseService } from '../../_services/';

declare var NgForm:any;
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  loginForm:FormGroup;
  submitted = false;
  errMsg:String;
  constructor(
    public ngZone: NgZone, // NgZone service to remove outside scope warning
    private _firebase:FirebaseService, 
    private formBuilder: FormBuilder,
    private _router : Router,
    // private _common: CommonService
  ) { }

  ngOnInit() {

    if(localStorage.getItem('uid')){
      this._router.navigate(['/product-list']);
    }

    this.loginForm = this.formBuilder.group({
      email: [null, [Validators.required, Validators.email, Validators.maxLength(200)]],
      password: [null, [Validators.required, Validators.minLength (6)]]
    })

  }

  get fval() {
    return this.loginForm.controls;
  }

  onFormSubmit():void {
    this.submitted = true;
    if (this.loginForm.invalid) {
      return;
    }
    let form = this.loginForm.value;
    
    // this._common.showLoader(true);
    this._firebase.SignIn(form.email, form.password).then(res => {
      this.ngZone.run(() => {
        // this._common.showLoader(false);
        localStorage.setItem('uid',res.user.uid);
        this._router.navigate(['/product-list'])
      });
      this._firebase.SetUserData(res.user);
    }).catch((err) => {
      // this._common.showLoader(false);
      this.errMsg = err.message;
    })
  }
  
}
